export const entityRemoveVisitComponent = {
    templateUrl: "admin/views/entity-remove-visit-component.html",
    //! @ngInject
    controller: function (
        $rootScope,
        $scope,
        DatabaseApi,
        toaster,
        wildcard,
        $filter,
        VisitInstanceModalService,
        noteConsts,
        entityNoteService,
        entityNewVisitModalService,
        generalUtils
    ) {
        const deregisterListener = $rootScope.$on('patient_calendar_update_visit_selection_type', (_, type) => {
            $scope.editShiftsParams.type = type;
        });

        $scope.$on("$destroy", () => {
            deregisterListener();
        });

        const initialize = () => {
            $rootScope.isDeleteVisitSideModalOpen = true;
            $scope.selectedVisits = entityNewVisitModalService.removedVisitsData.selectedVisits;
            $scope.patientId = entityNewVisitModalService.removedVisitsData.patientId;
            $scope.editShiftsParams = entityNewVisitModalService.removedVisitsData.editShiftsParams;

            entityNewVisitModalService.registerObserverCallback(
                "visits",
                "entityRemoveVisitComponent",
                getSelectedVisits
            );

            $scope.isNoteRequired = true;
            $scope.modalState = {
                selectedOption: { id: undefined },
                manualRemoveNote: {},
                approvalNote: {}
            }

            const visitsPreview = $scope.selectedVisits.map((visit, index) => {
                const startDateAndTime = $filter("mfShortTime")(visit.startTime, ['withDate']);
                const endTime = $filter("mfShortTime")(visit.endTime);
                return `${index + 1}. ${startDateAndTime} - ${endTime}`;
            });

            $scope.shouldAddApprovalNote = $scope.selectedVisits.some(visit => visit.isBilled || visit.isPaid || visit.isOnPayrollDraft);

            updateVisitsPreview();

            $scope.closeParentModal = () => {
                $scope.$parent.$ctrl.changeState(undefined);
                $rootScope.isDeleteVisitSideModalOpen = false;
                $rootScope.$emit("close_delete_visit_modal");
            };

            $scope.onClickDelete = () => {
                $scope.isRemoveNoteAnswer = entityNoteService.getAgencyEntityNoteSettingByType(noteConsts.NoteTypes.VISIT_MANUAL_REMOVE).predefinedAnswers.find(a => a.id === $scope.modalState.manualRemoveNote.notePredefinedAnswerId) !== undefined;

                const { isNoteValid, isPredefinedValid, isMessageValid } = entityNoteService.validateEntityNote(
                    $scope.modalState.manualRemoveNote,
                    $scope.isRemoveNoteAnswer ? noteConsts.NoteTypes.VISIT_MANUAL_REMOVE : 
                    noteConsts.NoteTypes.MISSED_VISIT_INSTANCE
                );
                if (!isNoteValid) {
                    $scope.noteValidations = { isPredefinedValid, isMessageValid };
                    return;
                }

                if($scope.shouldAddApprovalNote) {
                    const { isNoteValid, isPredefinedValid, isMessageValid } = entityNoteService.validateEntityNote(
                        $scope.modalState.approvalNote,
                        noteConsts.NoteTypes.ADJUSTMENT_APPROVAL
                    );
                    if (!isNoteValid) {
                        $scope.approvalNoteValidations = { isPredefinedValid, isMessageValid };
                        return;
                    }
                }
                

                loadItems();
            }

            $scope.handleNoteChanges = (note, updatedNote) => {
                $scope.modalState[note] = updatedNote;
            };
        }

        const loadItems = () => {
            $scope.isLoading = true;

            const body = getDeleteVisitsBody($scope.editShiftsParams.type, $scope.selectedVisits);

            const deleteVisitsUrl = wildcard(
                "agencies/:agencyId/agency_members/:agencyMemberId/bulk_remove_visit_instances",
                $rootScope.agencyId,
                $rootScope.agencyMemberId,
                $scope.patientId
            );

            DatabaseApi.post(deleteVisitsUrl, body).then((res) => {
                const skippedVisitsData = res.data.skippedVisitsAndMissingPermissions;
                if (!skippedVisitsData) {
                    toaster.pop("success", "Selected visits succesfully removed");
                } else {
                    VisitInstanceModalService.showSkippedVisitsErrorModal({
                        skippedVisitsAndMissingPermissions: skippedVisitsData,
                        updatedVisitsAmount: res.data.deletedVisitInstanceIds.length,
                        action: "delete"
                    });
                }
                $rootScope.$emit("refresh_visits");
                $scope.closeParentModal();
                generalUtils.scrollToElement('scroll-calendar');
            }, () => {
                toaster.pop("error", "Something went wrong", "Can't delete selected visits");
            }).finally(() => {
                $scope.isLoading = false;
            });
        }

        const getSelectedVisits = () => {
            $scope.selectedVisits = entityNewVisitModalService.selectedItems.visits;
            if (
                $rootScope.isDeleteVisitSideModalOpen &&
                $scope.selectedVisits.length === 0
            ) {
                $scope.closeParentModal();
            }
            else {
                updateVisitsPreview();
            }
        }

        const updateVisitsPreview = () => {
            $scope.visitsPreview = $scope.selectedVisits.map((visit, index) => {
                const startDateAndTime = $filter("mfShortTime")(visit.startTime, ['withDate']);
                const endTime = $filter("mfShortTime")(visit.endTime);
                return `${index + 1}. ${startDateAndTime} - ${endTime}`;
            });

            // If more than one visit selected adjust the message accordingly
            $scope.message = $scope.selectedVisits.length === 1 ? `Are you sure you want to remove the selected visit?` :
                `Are you sure you want to delete the following ${$scope.selectedVisits.length} selected visits?`;
        }

        const getDeleteVisitsBody = (deleteType, visits) => {
            const body = $scope.isRemoveNoteAnswer ? {
                removeMode: deleteType === "CURRENT_SHIFTS" ? "SingleVisits" : "WeeklyPattern",
                manualRemoveNote: entityNoteService.buildEntityNoteRequest(
                    $scope.modalState.manualRemoveNote,
                    noteConsts.NoteTypes.VISIT_MANUAL_REMOVE,
                ),
                visitInstanceIds: visits.map(visit => visit.visitInstanceId),
                shouldUpdateWeeklyTemplate: [
                    "ENTIRE_SERIES",
                    "GOING_FORWARD",
                    "CHOSEN_DAYS"
                ].includes(deleteType)
            } : {
                visitInstanceIds: visits.map(visit => visit.visitInstanceId),
                manualRemoveNote: entityNoteService.buildEntityNoteRequest(
                    $scope.modalState.manualRemoveNote,
                    noteConsts.NoteTypes.MISSED_VISIT_INSTANCE
                ),
            };

            if ($scope.shouldAddApprovalNote) {
                body.approvalNote = entityNoteService.buildEntityNoteRequest(
                    $scope.modalState.approvalNote,
                    noteConsts.NoteTypes.ADJUSTMENT_APPROVAL,
                )
            }

            const handledDeleteTypes = [
                "CURRENT_SHIFTS",
                "GOING_FORWARD",
                "UNTIL_DATE",
                "ENTIRE_SERIES",
                "CHOSEN_DAYS",
            ];

            if (!handledDeleteTypes.includes(deleteType) && $scope.isRemoveNoteAnswer) {
                toaster.pop("warning", "Something went wrong", "Unhandled Delete Mode");
                return;
            }

            return body;
        }

        this.$onDestroy = () => {
            entityNewVisitModalService.unregisterObserverCallback("visits", "entityRemoveVisitComponent");
        }

        initialize();
    }
};